import * as React from 'react';
import { find as _find } from 'lodash';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { RequestApiResult } from 'loopback-react-request';
import { Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router';
import { setTimeout } from 'timers';
import { TroughModel } from 'franke-trough-dependencies';
import TroughImage from '../TroughImage/TroughImage';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughDetailModal.messages';

import './TroughDetailModal.scss';

export interface TroughDetailModalProps {
  backUrl: string;
  troughId: string;
  troughs: RequestApiResult<TroughModel[]>;
}

export interface TroughDetailModalState {
  isOpen: boolean; 
  redirect: boolean;
}

export class TroughDetailModalPartial extends React.Component<TroughDetailModalProps, TroughDetailModalState> {
  constructor(props: TroughDetailModalProps) {
    super(props);
    this.state = {
      isOpen: false,
      redirect: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen && !this.state.redirect) {
      this.setState({
        isOpen: true,
        redirect: false,
      });
    }
  }

  public render() {
    const trough = this.selectedTrough;
    return (
      <div className="trough-detail-modal">
        <Modal 
          isOpen={this.state.isOpen} 
          backdrop={true}
          toggle={this.toggleModal}
          className="trough-detail-modal"
        >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
            <button onClick={this.toggleModal} className="close-btn">
              <FontAwesomeIcon icon={faTimes} />
            </button>
            {trough && (
              <div className="container">
              <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-6 trough-img">
                  <img src={`https://kwcws3d.blob.core.windows.net/cdn/images/troughs/${trough.fileName}.png`} className="img-fluid" alt={trough.name} />
                </div>
                <div className="col-12 col-md-6">
                  <div className="trough-heading border-bottom w-100 pb-2">
                    <h3>{trough.name}</h3>
                  </div>
                  <div className="trough-data border-bottom pt-4 pb-2">
                    <div className="row">
                      <div className="col-4">
                        <small><FormattedMessage {...MESSAGES.troughDetailModalWidth} /></small>
                        <p>{trough.throughWidth} mm</p>
                      </div>
                      <div className="col-4">
                        <small><FormattedMessage {...MESSAGES.troughDetailModalHeight} /></small>
                        <p>{trough.throughHeight} mm</p>
                      </div>
                      <div className="col-4">
                        <small><FormattedMessage {...MESSAGES.troughDetailModalDepth} /></small>
                        <p>{trough.throughDepth} mm</p>
                      </div>
                      <div className="col-12">
                        <small><FormattedMessage {...MESSAGES.troughDetailModalMinDimensions} /></small>
                        <p>{trough.minPlateWidth} mm x {trough.plateDepth.min} mm</p>
                      </div>
                    </div>
                  </div>
                  <div className="text-center pt-4">
                    {trough.fileName ? (
                      <a 
                        href={`https://kwcws3d.blob.core.windows.net/cdn/technical-drawings/${trough.fileName}.pdf`}
                        target="_blank"
                        className="btn btn-bordered btn-secondary font-weight-bold"
                      >
                        <FormattedMessage {...MESSAGES.troughDetailModalButton} />
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </Modal>
        {this.state.redirect && (
          <Redirect to={this.props.backUrl} />
        )}
      </div>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.setState({redirect: true}), 151);
  } 

  private get troughs(): TroughModel[] | undefined {
    const { troughs } = this.props;
    if (!troughs.loaded || troughs.loaded && !troughs.result) {
      return;
    }
    return troughs.result;
  }

  private get selectedTrough(): TroughModel | undefined {
    const troughs = this.troughs;
    if (!troughs || troughs && troughs.length === 0) {
      return;
    }
    return _find(troughs, (trough: TroughModel) => this.props.troughId === trough.id);
  }
}

export const TroughDetailModal = connect((state: GlobalPrivateState) => ({
  troughs: state.troughs,
}))(TroughDetailModalPartial);

export default TroughDetailModal;